// extracted by mini-css-extract-plugin
export var noSpinners = "_n5-6";
export var percentageInput = "_n5-7";
export var variantColor1 = "_n5-0";
export var variantColor2 = "_n5-1";
export var variantColor3 = "_n5-2";
export var variantColor4 = "_n5-3";
export var variantColor5 = "_n5-4";
export var variantColor6 = "_n5-5";